import EventBus from '@/utils/eventBus'

export default {
  data() {
    return {
      pageDataLoading: false
    }
  },
  computed: {
    isPageDataLoading() {
      return this.pageDataLoading
    }
  },
  methods: {
    pageRefreshed() {
      EventBus.emitEvent(EventBus.EventTypes.pageRefreshed)
    },
    openLinkNewTab(link) {
      let routeData = this.$router.resolve(link)
      window.open(routeData.href, '_blank')
    },
    openExternalLinkNewTab(link) {
      window.open(link, '_blank')
    },

    // Open a link directly using JS
    // Works around the Vue router sometimes not fully refreshing a page
    openLinkDirectly(link) {
      let routeData = this.$router.resolve(link)
      window.location.href = routeData.href
    },

    // Start a main page network access
    // Handles page loading status
    pageLoadData(dataLoadPromise) {
      return new Promise((resolve, reject) => {
        this.$data.pageDataLoading = true

        this.$store.commit('page/setPageError', null)

        return dataLoadPromise.then(response => {
          this.$data.pageDataLoading = false

          return resolve(response)
        })
        .catch(error => {
          this.$data.pageDataLoading = false

          return reject(error)
        })
      })
    },

    // Provides a function to use in catch's when using pageLoadData()
    // Handles network, permission & other errors gracefully without harsh popup dialog boxes
    handlePageLoadError(error) {
      // Check error type
      if(error.response == null) {
        this.$store.commit('page/setPageError', { message: 'Error accessing the page. Check your network connection and try again', retryAvailable: true })
      } else {
        if(error.response.status == 403) {
          this.$store.commit('page/setPageError', { message: 'Access denied to this page', isError: true })
        } else {
          this.$store.commit('page/setPageError', { message: (error.message || 'There was an error accessing this page'), retryAvailabe: true, isError: true })
        }
      }
    }
  }
}